var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstcolored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 60C46.5686 60 60 46.5686 60 30C60 13.4314 46.5686 0 30 0C13.4314 0 0 13.4314 0 30C0 46.5686 13.4314 60 30 60Z",
    fill: "url(#paint0_radial_16_403)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 60C46.5686 60 60 46.5686 60 30C60 13.4314 46.5686 0 30 0C13.4314 0 0 13.4314 0 30C0 46.5686 13.4314 60 30 60Z",
    fill: "url(#paint1_radial_16_403)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7271 14H35.2394L35.384 14.0289L35.4054 14.0333L35.4112 14.0345C35.4581 14.0444 35.5072 14.0526 35.5557 14.0533L35.5731 14.0536C36.8042 14.0856 38.0363 14.15 39.237 14.4472L39.2421 14.4484C41.9599 15.1313 43.9419 16.7091 45.0716 19.3088L45.0731 19.3123C45.6795 20.7174 45.8609 22.2072 45.9251 23.7283L45.9257 23.7421C45.9356 24.045 45.9636 24.3509 45.9931 24.6555L46 24.7271V35.2394L45.9711 35.384L45.9668 35.405L45.9655 35.4112C45.9556 35.4581 45.9474 35.5073 45.9467 35.5557L45.9464 35.5731C45.9144 36.8045 45.8499 38.0367 45.5527 39.2374L45.5514 39.2426C44.8685 41.9601 43.2908 43.9418 40.6915 45.0716L40.6878 45.0732C39.2827 45.6794 37.7929 45.8609 36.2717 45.9251L36.2579 45.9257C35.955 45.9356 35.6491 45.9636 35.3445 45.9931L35.2729 46H24.7606L24.616 45.9711L24.595 45.9668L24.5888 45.9655C24.5419 45.9556 24.4927 45.9474 24.4443 45.9467L24.4269 45.9464C23.1955 45.9144 21.9633 45.8499 20.7626 45.5527L20.7574 45.5514C18.0401 44.8685 16.0583 43.2909 14.9285 40.6918L14.927 40.6882C14.3199 39.2817 14.1388 37.7901 14.0748 36.2673L14.0746 36.2647C14.0642 36.1039 14.0514 35.9429 14.0385 35.7832L14.038 35.7777L14.036 35.7527C14.0246 35.6101 14.013 35.4666 14.0034 35.3243L14 35.2741V24.7606L14.0289 24.616L14.0333 24.5946L14.0345 24.5888C14.0444 24.5419 14.0526 24.4928 14.0533 24.4443L14.0536 24.4269C14.0856 23.1958 14.15 21.9637 14.4472 20.763L14.4484 20.758C15.1312 18.0402 16.7089 16.0583 19.3084 14.9285L19.3119 14.927C20.7171 14.3206 22.2071 14.1391 23.7283 14.0749L23.7421 14.0743C24.0451 14.0644 24.3509 14.0364 24.6555 14.0069L24.7271 14ZM24.8705 16.9767C24.5803 17.0046 24.2212 17.0367 23.8472 17.0493C22.4556 17.1084 21.398 17.2692 20.4931 17.6593C18.7986 18.3964 17.8091 19.6002 17.3361 21.4807C17.1237 22.3404 17.0611 23.2894 17.0296 24.4969C17.0257 24.7195 17.0004 24.9122 16.9767 25.0497V35.1722C16.9844 35.2797 16.9934 35.3917 17.0037 35.5205L17.0039 35.5231L17.0042 35.5256L17.0049 35.5348C17.0179 35.6955 17.0328 35.8814 17.0451 36.0716L17.0472 36.1035L17.0488 36.1399C17.1074 37.5381 17.2679 38.5992 17.6594 39.507C18.3964 41.2012 19.6 42.1906 21.48 42.6637C22.34 42.8762 23.2893 42.9389 24.4969 42.9704C24.7195 42.9743 24.9121 42.9996 25.0497 43.0233H35.1296C35.4197 42.9954 35.779 42.9633 36.1528 42.9507C37.5443 42.8916 38.6018 42.7308 39.5068 42.3408C41.2012 41.6037 42.1906 40.4 42.6637 38.52C42.8762 37.66 42.9389 36.7107 42.9704 35.5031C42.9743 35.2805 42.9996 35.0879 43.0233 34.9503V24.8704C42.9954 24.5803 42.9633 24.221 42.9507 23.8472C42.8916 22.4554 42.7309 21.3982 42.3408 20.4934C41.6037 18.7987 40.3999 17.8093 38.5193 17.3361C37.6596 17.1237 36.7106 17.0611 35.5031 17.0296C35.2805 17.0257 35.0878 17.0004 34.9503 16.9767H24.8705Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 35.1778C32.8326 35.1778 35.1776 32.864 35.1776 30.0625C35.1776 27.178 32.8846 24.8329 30.0518 24.8225C27.1569 24.8225 24.8223 27.126 24.8223 29.9898C24.8223 32.8537 27.1361 35.1778 30 35.1778ZM38 30.0103C38 34.441 34.4099 38.0103 29.9792 38C25.5694 37.9897 22 34.4098 22 29.9897C22 25.559 25.5902 21.9897 30.0208 22C34.4307 22.0103 38 25.5902 38 30.0103Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9903 19.3326C38.9823 19.3326 39.778 20.1184 39.778 21.1006C39.778 22.0827 38.9823 22.8881 38.0002 22.8881C37.0279 22.8881 36.2224 22.0827 36.2224 21.1006C36.2322 20.1281 37.0279 19.3326 37.9903 19.3326Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16_403",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9376 64.6212) rotate(-90) scale(59.4645 55.3066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_16_403",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-10.0503 4.3223) rotate(78.6806) scale(26.5808 109.567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstcolored);
export default __webpack_public_path__ + "static/media/instcolored.1a6c9bdf1de19beba7bb74377fb6d30a.svg";
export { ForwardRef as ReactComponent };